import React from 'react'
import Footer from '../Footer'
import BU2 from '../BU2'

function BUTwo() {
    window.scrollTo(0,0);
    return (
        <div>
            <BU2/>
            <Footer/>
        </div>
    )
}

export default BUTwo
